<!-- @veltra/icons generated sha256:507740f6ecaac714 gen:8 source:src/svg/normal/server.svg -->
<script setup lang="ts">
defineOptions({ name: 'Server' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
    <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
    <path d="M6 6h.01M6 18h.01" />
  </svg>
</template>
